const selectors = {
  frame: '[data-ticker-frame]',
  scale: '[data-ticker-scale]',
  text: '[data-ticker-text]',
  clone: 'data-clone',
};

const attributes = {
  autoplay: 'autoplay',
  speed: 'speed',
};

const classes = {
  animation: 'ticker--animated',
  unloaded: 'ticker--unloaded',
  comparitor: 'ticker__comparitor',
};

const settings = {
  speed: 1.63, // 100px going to move for 1.63s
  space: 100, // 100px
};

class Ticker extends HTMLElement {
  constructor() {
    super();

    this.autoplay = this.hasAttribute(attributes.autoplay);
    this.scale = this.querySelector(selectors.scale);
    this.text = this.querySelector(selectors.text);
    this.speed = this.hasAttribute(attributes.speed) ? this.getAttribute(attributes.speed) : settings.speed;
    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add(classes.comparitor);
    this.appendChild(this.comparitor);
    this.scale.classList.remove(classes.unloaded);
    this.checkWidthEvent = this.checkWidth.bind(this);
  }

  connectedCallback() {
    this.checkWidth();
    this.addEventListener('theme:ticker:refresh', this.checkWidthEvent);

    document.addEventListener('theme:resize:width', this.checkWidthEvent);
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.checkWidthEvent);
  }

  checkWidth() {
    const padding = window.getComputedStyle(this).paddingLeft.replace('px', '') * 2;

    if (this.clientWidth - padding < this.comparitor.clientWidth || this.autoplay) {
      this.text.classList.add(classes.animation);
      if (this.scale.childElementCount === 1) {
        this.clone = this.text.cloneNode(true);
        this.clone.setAttribute(selectors.clone, '');
        this.scale.appendChild(this.clone);

        if (this.autoplay) {
          for (let index = 0; index < 10; index++) {
            const cloneSecond = this.text.cloneNode(true);
            cloneSecond.setAttribute(selectors.clone, '');
            this.scale.appendChild(cloneSecond);
          }
        }

        const animationTimeFrame = ((this.text.clientWidth / settings.space) * Number(this.speed)).toFixed(2);

        this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);
      }
    } else {
      this.text.classList.add(classes.animation);
      let clone = this.scale.querySelector(`[${selectors.clone}]`);
      if (clone) {
        this.scale.removeChild(clone);
      }
      this.text.classList.remove(classes.animation);
    }
  }
}

export {Ticker};
